import React, { useContext, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { size } from "lodash";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import AuthMain from "./components/Auth/Main";
import AppMain from "./components/Main";
import UserContext from "./utils/Contexts/UserContext";
import ThemeContext from "./utils/Contexts/ThemeContext";
import Constant from "./components/Constants";

import "./App.css";

function App() {
  const { userData } = useContext(UserContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { themeStatus } = Constant();
  const [router, setRouter] = useState(null);

  useEffect(() => {
    if (userData) {
      // Define routes for app using createBrowserRouter for useBloacker hook
      const routerInstance = createBrowserRouter([
        !size(userData)
          ? {
              path: "/*",
              element: <AuthMain />,
            }
          : {
              path: "/*",
              element: <AppMain />,
            },
      ]);
      setRouter(routerInstance);
    }
  }, [userData]);

  return (
    <div className={`app-backlinks-factory ${themeStatus?.[selectedTheme]}`}>
      {router ? (
        <>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                background: "var(--toast-bg)",
                color: "var(--toast-color)",
                fontSize: "22px",
                maxWidth: "max-content",
                marginRight: "10px",
                paddingLeft: "13px",
                paddingTop: "13px",
                paddingBottom: "13px",
                paddingRight: "13px",
              },
              success: {
                style: {
                  border: "2px solid #02C9A6",
                  boxShadow: "0 0 10px rgba(98, 211, 68, 0.4)",
                },
              },
              error: {
                style: {
                  border: "2px solid #ED4C78",
                  boxShadow: "0 0 10px rgba(255, 75, 75, 0.4)",
                },
              },
            }}
          />
          <RouterProvider router={router} />
        </>
      ) : (
        ""
      )}
    </div>
  );
}

export default App;
